import * as React from "react";

interface FormGroupProps {
	label: string;
	htmlFor?: string;
	labelColClass?: string;
	inputColClass?: string;
	error?: string;
	children: React.ReactNode;
}

export function FormGroup({
	label,
	htmlFor,
	labelColClass = "col-xs-2",
	inputColClass = "col-xs-10",
	error,
	children
}: FormGroupProps) {
	return (
		<div className={`form-group${error ? " has-error" : ""}`}>
			<label htmlFor={htmlFor} className={`control-label ${labelColClass}`}>{label}</label>
			<div className={inputColClass}>
				{children}
				{error && <span className="help-block">{error}</span>}
			</div>
		</div>
	);
}
